import { BasketPageContext } from '../context/BasketPageProvider';
import { useContext } from 'react';

export const useBasketPage = () => {
    return useContext(BasketPageContext);
};
